import {updateFactory} from '@modifi/redux'
import {aCloseDialog} from '@modifi/plugin-dialogs'
import {routerActions} from '@modifi/router'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'
import {aDeleteTransactionEntity} from '../../features/transactions/store'

const client = getAuthenticatedAdminAresClient()

const {actions, selectors, reducer} = updateFactory({
  rootSelector: state => state?.modules?.deleteTransaction,
  actionNamePrefix: `transactions/delete-transaction`,
  submitRequest: (a, transactionId, reason, refinancingPartnerTag) => async dispatch => {
    dispatch(a.pendingAction())
    try {
      await client.BankTransactions.deleteTransaction({
        transactionId,
        reason,
        refinancingPartnerTag,
      })
      // remove it from transactions
      dispatch(aDeleteTransactionEntity(transactionId))
    } catch (e) {
      return dispatch(a.errorAction(e))
    }
    dispatch(a.successAction())
    // redirect to transactions page
    dispatch(routerActions.replace('/'))
    return dispatch(aCloseDialog())
  },
})

export default reducer

export const {
  selectUpdateErrorMessage: selectDeleteErrorMessage,
  selectUpdatePending: selectDeletePending,
} = selectors

export const {aSubmit: aDeleteTransaction, aReset: aCleanupDelete} = actions
